import { Location, NgClass, NgStyle } from "@angular/common";
import { Component, ChangeDetectorRef, HostListener, inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { doc, Firestore, getDoc } from "@angular/fire/firestore";
import { FormsModule } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { LoadingService } from "@core/loading.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { UtilityService } from "@core/utility.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { EMPTY, from, Subscription, throwError } from "rxjs";
import { catchError, map, switchMap, take } from "rxjs/operators";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { LoginDataResolverService } from "src/app/services/login-data-resolver.service";
import { PaymentService } from "src/app/services/payment.service";
import { ResourceLoaderService } from "src/app/services/resource-loader.service";
import { environment } from "src/environments/environment";
import { v4 as uuidv4 } from "uuid";
import { SyndicateRepositoryService } from "../../syndicate/syndicate-repository.service";
import { ToastFacadeService } from "@core/toast-facade.service";
import {
  CheckoutFlowRedirectReturn,
  CheckoutFlowService,
} from "src/app/services/checkout-flow.service";
import {
  PreAuthCheckoutFlowHost,
  PreAuthCheckoutFlowService,
} from "./services/pre-auth-checkout-flow.service";
declare var window;
declare var Frames: Data;
@Component({
  selector: "app-pre-authpage",
  templateUrl: "./pre-authpage.component.html",
  styleUrls: ["./pre-authpage.component.scss", "../onesignal.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    FormsModule,
    TranslatePipe,
  ],
})
export class PreAuthpageComponent implements OnInit, OnDestroy {
  @ViewChild("stepper", { static: false }) stepper: MatStepper;
  private originalOnReady: Data;
  storedCards = [];
  count: any = 0;
  isPaymentDone: boolean;
  paymentReceived: any;
  payment_status: any;
  isPaymill: any = false;
  isCheckOutCom = false;
  myuuid: string = uuidv4();
  pType: string;
  productDetails: any;
  loaded: boolean;
  modalCtrl: any;
  purchaseDetail: any;
  paymentProsubId: any;
  insertCustomerPurchaseRes: any;
  responseObject: any;
  selectedCard: string;
  addNewCardInProgress: boolean = false;
  addingCard: boolean;
  pathString: any;
  offer: any;
  redirectlink: Data;
  showCheckOutComSpinner = false;
  isCheckoutComform = true;
  userData: Data;
  checkOutComData: Data;
  paymentDone = false;
  sysRef: Subscription;
  hideSpinner: boolean;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  paymnetServiceSub: object;
  triggerActivatingData: any;
  preferredCurrency = "GBP";
  currencySymbol = "£";
  currencyBasedPType: string;
  customerPurchaseResponce: Data;
  stepperIndex = 0;
  customerPurchaseEncryptedId: Data;
  jackpotTriggerObj: {
    alias: string;
    lines: number;
    jackpot: string;
    price: number;
    offer_link_id: number;
    offer_id: number;
    free_jackpot: boolean;
    alternate_free_jackpot: boolean;
    free_offer_id: string | number;
  };
  origin = window.location.origin;
  subscription = new Subscription();
  callInt2sub: Subscription;
  timerOn = true;
  timeOut: boolean;
  subCheckoutId: Subscription;
  replaceScript = false;
  paymentReason = "rollover_jackpot";
  private getCheckoutIdSubscription: Subscription;
  @ViewChild("timer", { static: false }) timerspan: Data;
  public isButtonDisabled: boolean;
  public language: string;
  public keys: Data;
  public token: string;
  public errorMessage: string;
  public errorStack: string[] = [];
  public TP1: string = window.localStorage.getItem("TP1");
  public TP2: string = window.localStorage.getItem("TP2");
  public TP3: string = window.localStorage.getItem("TP3");
  public T_ID: string = window.localStorage.getItem("T_ID");
  private framesInitRetryCount = 0;
  private framesInitRetryDelay = 5000;
  private framesInitMaxRetry = 3;
  private flowInitRetryCount = 0;
  private readonly flowInitMaxRetry = 3;
  private readonly flowInitRetryDelay = 5000;
  private checkoutFlowRedirectHandled = false;
  private flowMountAttempted = false;
  checkoutFlowReady = false;
  private getCheckOutComResponseSubscription?: Subscription;
  useJackpotTriggerCheckoutFlow = false;
  private checkoutApiKeysReady = false;
  userId: string;
  paymentMode: string;
  private checkoutFlowService = inject(CheckoutFlowService);
  private preAuthCheckoutFlowService = inject(PreAuthCheckoutFlowService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  constructor(
    private firestore: Firestore,
    private paymentService: PaymentService,
    private snackService: MySnackBarService,
    private location: Location,
    private utilityService: UtilityService,
    private activeRoute: ActivatedRoute,
    private GTMSegment: GTMSegmentService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private loginData: LoginDataResolverService,
    private loadingService: LoadingService,
    private syndicateService: SyndicateRepositoryService,
    public translate: TranslateService,
    public angularFireFunctions: AngularFireFunctions,
    private sanitizer: DomSanitizer,
    private toastFacade: ToastFacadeService,
    private resourceLoader: ResourceLoaderService
  ) {
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.userDetails$.subscribe(
      (user: Data) => {
        this.userData = user;
        this.preferredCurrency = user?.preferred_currency ? user?.preferred_currency : "GBP";
        this.authService.getCurrencyList$.subscribe((data: Data) => {
          const CurrencyDetails = data?.details?.find((x: Data) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ? CurrencyDetails?.currency_symbol : "£";
        });
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
    this.purchaseDetail = this.loginData.userProduct$.value;
    this.paymentService.userProduct = this.loginData.userProduct$.value;
    localStorage.removeItem("d");
    // Translated iframe contect according to selected Language
    if (window?.wpwlOptions) {
      window.wpwlOptions.locale = this.selectedLanguage ?? "en";
    }
  }

  @HostListener("window:message", ["$event"])
  onMessage(e): void {
    if (e && e?.data && e?.data?.for === "paymentDone") {
      // To check for active current session or manually login using token
      this.authService.commonUserCheck(() => {
        this.afterNewCardPaymentDone();
      });
    }
  }

  async ngOnInit() {
    
    await this.authService
      ?.getUid("PreAuthpageComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error: any) => {
        return error;
      });
    const qp = this.actRoute.snapshot?.queryParams ?? {};
    this.paymentMode = qp.pt ?? "";
    this.useJackpotTriggerCheckoutFlow = qp.jackpotTrigger === "requested";
    this.redirectlink = this.sanitizer.bypassSecurityTrustResourceUrl(environment.checkOutUrl);
    if (this.useJackpotTriggerCheckoutFlow) {
      this.errorMessage = "Loading secure card form...";
      this.showCheckOutComSpinner = true;
      void this.preAuthCheckoutFlowService.preloadSdk();
      this.prefetchCheckoutApiKeys();
    }
    let offerId;
    let offer_p_type;
    let preAuthAmount;
    if (!this.userId) {
      this.authService.errorHandlerLogs('[PreAuth] Unauthenticated user on /pre-auth, skipping Firestore reads.');
    } else {
      this.subscription.add(
        from(getDoc(doc(this.firestore, "general_modules/system_reference"))).pipe(
          switchMap((ref: any) => {
            const preAuthOffer = ref.data();
            offerId = preAuthOffer?.pre_auth_offer_id;
            preAuthAmount = preAuthOffer?.pre_auth_amount;

            // Fetch offer listing document
            return this.authService.getAngularFireStore(`/general_modules/offer_listing_v1/offers/${offerId}`, "get").pipe(
              switchMap((data: Data) => {
                offer_p_type = data?.data()?.p_type ?? 10;

                // Fetch PType by preferred currency
                return this.paymentService.getPTypeByPreferredCurrency(this.preferredCurrency).pipe(
                  map((currencyData) => {
                    this.currencyBasedPType = currencyData[0]?.id ? currencyData[0].id : "10";

                    return offer_p_type;
                  }),
                  switchMap(() =>
                    this.paymentService.getPTypeByOffer(offer_p_type).pipe(
                      map((currency: Data) => {
                        const offerCurrencyData = currency?.data() as { valid_currency: Array<string> };
                        const offerValidCurrencyAry = offerCurrencyData?.valid_currency;

                        // Determine PType based on offer and preferred currency
                        if (Array.isArray(offerValidCurrencyAry) && offerValidCurrencyAry.includes(this.preferredCurrency)) {
                          this.pType = String(offer_p_type);
                        } else {
                          this.pType = this.currencyBasedPType;
                        }

                        this.selectedCard = this.pType;
                        if (this.selectedCard === "10") {
                          this.isPaymill = true;
                          this.isCheckOutCom = false;
                        } else if (this.selectedCard === "21") {
                          this.isCheckOutCom = true;
                          this.isPaymill = false;
                          this.ngAfterViewInitCheckout();
                        }

                        // Proceed with payment
                        this.payment(offerId, preAuthAmount);
                      })
                    )
                  )
                );
              })
            );
          }),
          catchError((err) => {
            this.authService.errorHandlerLogs('[PreAuth] Firestore error in ngOnInit chain:', err);
            return EMPTY;
          })
        ).subscribe()
      );
    }

    if (this.useJackpotTriggerCheckoutFlow) {
      this.handleCheckoutFlowRedirect();
    }

    this.purchaseDetail = this.loginData.userProduct$.value;
    this.authService.userDetails$.subscribe(
      (user: Data) => {
        this.userData = user;
        this.preferredCurrency = user?.preferred_currency ? user?.preferred_currency : "GBP";
        this.authService.getCurrencyList$.subscribe((data: Data) => {
          const CurrencyDetails = data?.details?.find((x: Data) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ? CurrencyDetails?.currency_symbol : "£";
        });
      },
      (err) => {
        return err;
      }
    );

    this.authService.callSigUpForSalesResponse$.subscribe((d) => {
      if (d && window.location.href.search("pre-auth") > -1) {
        if (d && d?.response?.status === "FAIL") {
          this.authService.callSigUpForSalesResponse$.next(null);
          const proSub = localStorage.getItem("prosub_id");
          this.authService.logout().then();
          if (proSub === null) return;
          this.router.navigateByUrl(`partial-registration?prosub_id=${proSub}`);
          if (d?.response?.message === "MSN_INVALID") {
            const message = "Registration failed, please enter a correct phone number.";
            this.authService.showAnonymousUserMessage(message);
            return;
          }
          this.authService.showAnonymousUserMessage();
        }
      }
    });

    this.authService.userDetails$.subscribe((r) => {
      let userDetails = r;
    });

    this.paymentService.triggerActivatingData$.subscribe((data) => {
      this.triggerActivatingData = data && Object.keys(data).length ? data
        : JSON.parse(localStorage.getItem('JackpotTriggerData') || '{}');
    });

    // Check if wpwlOptions and onReady function exist
    if (window.wpwlOptions) {
      if (!this.originalOnReady) {
        this.originalOnReady = window.wpwlOptions.onReady;
      }
      // Override the onReady function
      window.wpwlOptions.onReady = () => {
        // Use Angular to select the button if needed
        const button: HTMLButtonElement = document.querySelector(".wpwl-button-pay");
        if (button) {
          // Modify button styles
          this.translate.get("pre-auth.verify").subscribe((translatedText: string) => {
            button.innerHTML = ""; // Clear current content
            button.innerHTML = translatedText; // Set translated text
          });
          button.style.cssText += "width:100%;padding:1.5vh;border-radius:10px";
          setTimeout(() => {
            if (button) {
              button.disabled = true;
            }
          }, 2000);
        }
      };
    }
  }
  processCustomerPurchase(pre_auth_offer_id, pre_auth_amount) {
    const resolvedPType = this.selectedCard || this.pType;
    if (!resolvedPType) {
      return;
    }

    return (this.paymnetServiceSub = this.paymentService
      .insertCustomerPurchase(
        {
          p_type: resolvedPType,
          offer_id: pre_auth_offer_id,
          offers: { price: pre_auth_amount },
        },
        "/api_post_request/insert_customer_purchase_pre_auth"
      )
      .subscribe(
        (result: any) => {
          if (result?.response?.status === "SUCCESS") {
            this.insertCustomerPurchaseRes = result;
            this.customerPurchaseResponce = result.response;
            this.purchaseDetail = result;
            this.purchaseDetail["offer_id"] = pre_auth_offer_id;
            this.purchaseDetail["price"] = pre_auth_amount;
            this.loaded = true;
            this.timer(600);
            if (this.userData) {
              let data = {
                ...this.purchaseDetail,
                ...{ customer_purchase: this.customerPurchaseResponce },
                ...this.userData,
              };
              this.checkOutComData = data;
              if (this.useJackpotTriggerCheckoutFlow && this.isCheckOutCom) {
                void this.prepareJackpotCheckoutFlow();
              }
            } else {
              const userDocRef = doc(this.firestore, `users/${this.userId}`);
              getDoc(userDocRef).then((user) => {
                this.userData = user.data();
                const data = {
                  ...this.purchaseDetail,
                  ...{ customer_purchase: this.customerPurchaseResponce },
                  ...this.userData,
                };
                this.checkOutComData = data;
                if (this.useJackpotTriggerCheckoutFlow && this.isCheckOutCom) {
                  void this.prepareJackpotCheckoutFlow();
                }
              }).catch((error) => {
                this.authService.errorHandlerLogs('Error fetching user details', error);
              });
            }
          } else {
            if (result && result.message === "Timeout has occurred") {
              this.addingCard = false;
              this.addNewCardInProgress = false;
              // this.showAddNewCard = true;
              // this.proceed = true;
              this.isPaymentDone = false;
              //this.authService.showToast(result.message + ", Please try again!", "Error", "");
              this.authService.getConstantsMsg(result.message?.error_code).then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong!",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              });
              return;
            }
          }
        },
        (err) => {
          return err;
        }
      ));
  }
  payment(pre_auth_offer_id, pre_auth_amount) {
    this.paymentService.triggerActivatingData$.subscribe((data) => {
      this.triggerActivatingData = data;
    });

    this.activeRoute.queryParamMap.subscribe((params: any) => {
      this.productDetails = params;
      if (this.selectedCard === "10") {
        this.subCheckoutId = this.paymentService.getCheckoutId("1.00", "GBP", {}, this.paymentReason).subscribe((data) => {
          if (data.id) {
            if (this.replaceScript) {
              document
                .getElementById("pwaPayment")
                .setAttribute("src", `https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=${data?.id}`);
            } else {
              this.utilityService?.loadScript(
                [`https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=${data?.id}`],
                true
              );
              this.utilityService.checkIframeInputFocus();
            }
            this.replaceScript = true;
            this.pathString = String(data?.id);
            this.loadingService.dismiss();
            this.processCustomerPurchase(pre_auth_offer_id, pre_auth_amount);
          }
        });
      } else if (this.selectedCard === "21") {
        this.loadingService.dismiss();
        this.pathString = String(this.myuuid);
        this.processCustomerPurchase(pre_auth_offer_id, pre_auth_amount);
      }
    });
  }

  getCheckCardDetailId() {
    if (!this.storedCards) return;
    return this.storedCards?.find((x) => x.isChecked);
  }

  async callInt2() {
    this.paymentService.getOptionalPage("pre-auth-4c").then(async (resp) => {
      const post_name = resp;
      if (post_name === "free-reg-complete-profile") {
        try {
          this.authService.userDetails$.pipe(take(1)).subscribe(
            (user: any) => {
              if (user?.minimal_required == true) {
                //this.fetchSyndicateAndShowTicket();
              } else {
                // this.router.navigate([`/${post_name}`]);
                // this.router.navigateByUrl(`${post_name}`);
                this.router.navigateByUrl(
                  `/${post_name +
                  "&" +
                  "TP1=" +
                  this.TP1 +
                  "&" +
                  "TP2=" +
                  this.TP2 +
                  "&" +
                  "TP3=" +
                  this.TP3 +
                  "&" +
                  "T_ID=" +
                  this.T_ID
                  }`
                );
              }
            },
            (err) => {
              //this.snackService.openSnackBar("Something went wrong (user)", "", "custom-class-fail", "Error");
              /* const msg = this.translatedToastMsg?.["1013"]?.[this.selectedLanguage];
              this.authService.showToast(msg ? msg : "Something went wrong (user)", "Error", ""); */
              this.authService.getConstantsMsg("1013").then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong (user)",
                    line_2: "",
                  },
                  style: {
                    type: "Error",
                    icon: "tick circle error.svg",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              });
            }
          );
        } catch (error) {
          //this.snackService.openSnackBar("Something went wrong", "", "custom-class-fail", "Error");
          /*  const msg = this.translatedToastMsg?.["1014"]?.[this.selectedLanguage];
           this.authService.showToast(msg ? msg : "Something went wrong", "Error", ""); */
          this.authService.getConstantsMsg("1014").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong",
                line_2: "",
              },
              style: {
                type: "Error",
                icon: "tick circle error.svg",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          });
        }
      } else {
        //this.router.navigate([`/${post_name}`]);
        // this.router.navigateByUrl(`/${post_name}`);
        this.router.navigateByUrl(
          `/${post_name +
          "&" +
          "TP1=" +
          this.TP1 +
          "&" +
          "TP2=" +
          this.TP2 +
          "&" +
          "TP3=" +
          this.TP3 +
          "&" +
          "T_ID=" +
          this.T_ID
          }`
        );
      }
    });
  }

  load(e) {
    this.count++;
    if (this.count > 2) {
      this.isPaymentDone = true;
    }
  }

  afterNewCardPaymentDone(): void {
    if (!this.paymentReceived && localStorage.getItem("d")) {
      this.paymentReceived = true;
      const urlData = JSON.parse(localStorage.getItem("d"));
      setTimeout(() => {
        const path_id = "At4Vyy58QQ2vknYAhw7T";
        const doc_data = {
          id: urlData?.id,
          respource_url: urlData?.resourcePath,
          cehckout_done_at: new Date(),
        };
        const dv = { docId: String(this.pathString) };
        const method = "update";

        this.authService.getV2CloudFunction("updatefirestoredoc", {
          path_id,
          doc_data,
          dv,
          method,
        }).subscribe({
          error: (err) => {
            this.authService.errorHandlerLogs('Error updating card', err);
          }
        });

        this.paymentService
          .checkPaymentStatus(urlData?.id, this.paymentMode)
          .pipe(take(1))
          .subscribe(
            (payment_status) => {
              this.payment_status = payment_status;
              if (
                payment_status?.result?.description.search("succeeded") > -1 &&
                payment_status?.response?.status !== "SUCCESS"
              ) {
                this.isPaymentDone = false;
                const toastCode = this.paymentService.mapPaymentToastCode(payment_status);
                const fallback = this.paymentService.mapPaymentToastFallback(payment_status);
                this.toastFacade.showByCode(toastCode, fallback, {
                  journey: "payment",
                  trigger: "manual_login_payment_result",
                  reason_code: this.paymentService.mapPaymentReasonCode(payment_status),
                });

                const path_id = "At4Vyy58QQ2vknYAhw7T";
                const doc_data = { payment_response: payment_status };
                const dv = { docId: String(this.pathString) };
                const method = "update";

                this.authService.getV2CloudFunction("updatefirestoredoc", {
                  path_id,
                  doc_data,
                  dv,
                  method,
                }).subscribe({
                  next: () => {
                    this.payment_status = payment_status;
                  },
                  error: (err) => {
                    this.authService.errorHandlerLogs('Error in updatefirestoredoc - afterNewCardPaymentDone:', err);
                  }
                });

                this.paymentService
                  .updatePaymentReqAndRes(
                    {
                      ...this.purchaseDetail,
                      customer_purchase_id: this.insertCustomerPurchaseRes?.response?.customer_purchase_id,
                    },
                    payment_status,
                    { is_preauth: true }
                  )
                  .subscribe(
                    (sqlAPICall) => {
                      if (sqlAPICall && sqlAPICall?.response?.status !== "SUCCESS") {
                        this.authService.getConstantsMsg("1015").then((translatedMsg) => {
                          const defaultMsg = {
                            message: {
                              line_1: "Something went wrong!",
                              line_2: "",
                            },
                            style: {
                              type: "Error",
                              icon: "tick circle error.svg",
                            },
                          };
                          this.authService.showToastMessage(translatedMsg, defaultMsg);
                        });
                        return;
                      }
                      this.paymentService.salesJournyPaymentDetails$.next(
                        sqlAPICall?.response?.encrypt_syndicate_id
                      );
                      if (this.isJackpotTriggerPreAuthRequested()) {
                        this.completeJackpotTriggerPreAuthAfterPayment();
                      } else {
                        this.callInt2();
                      }
                    },
                    (err) => {
                      return err;
                    }
                  );

                return;
              }
              const toastCode = this.paymentService.mapPaymentToastCode(payment_status);
              const fallback = this.paymentService.mapPaymentToastFallback(payment_status);
              this.toastFacade.showByCode(toastCode, fallback, {
                journey: "payment",
                trigger: "manual_login_payment_result",
                reason_code: this.paymentService.mapPaymentReasonCode(payment_status),
              });
              this.isPaymentDone = false;
              return this.location.back();
            },
            (err) => {
              return err;
            }
          );
      }, 1000);

      setTimeout(() => {
        let elements = document.getElementsByName("wpwl-button-pay");
        if (elements.length) {
          document.getElementsByClassName("wpwl-button-pay")[0].innerHTML = "Verify";
        }
      }, 5000);
    }
  }

  timer(remaining) {
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;

    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    // document.getElementById("timer").innerHTML = m + ":" + s;
    if (this.timerspan) {
      this.timerspan.nativeElement.innerHTML = m + ":" + s;
    }
    remaining -= 1;

    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.timer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }

    // Do timeout stuff here
    this.timeOut = true;
    this.addingCard = false;
    this.addNewCardInProgress = false;
    // this.showAddNewCard = true;
    //this.authService.showToast("Session timeout has occur, Please try again!", "Error", "");
    this.authService.getConstantsMsg("1100").then((translatedMsg) => {
      const defaultMsg = {
        message: {
          line_1: "Session timeout has occur, Please try again!",
          line_2: "",
        },
        style: {
          type: "Error",
          icon: "tick circle error.svg",
        },
      };
      this.authService.showToastMessage(translatedMsg, defaultMsg);
    });

    //alert("Timeout for otp");
    this.subscription?.add(this.callInt2sub);
    this.subscription?.unsubscribe();

    clearTimeout(0);
    //this.payment();

    // window.location.reload();
  }

  public ngAfterViewInitCheckout(): void {
    this.isButtonDisabled = true;

    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        const lang = l ? l : "en";

        switch (lang) {
          case "en":
            this.language = "EN-GB";
            break;
          case "de":
            this.language = "DE-DE";
            break;
          case "es":
            this.language = "ES-ES";
            break;
          case "fr":
            this.language = "FR-FR";
            break;
          case "it":
            this.language = "IT-IT";
            break;
          default:
            this.language = "EN-GB";
        }
      },
      (err) => {
        this.language = "EN-GB";
        return err;
      }
    );

    const queryParams = this.actRoute.snapshot.queryParams || {};
    if (this.useJackpotTriggerCheckoutFlow) {
      if (this.checkoutApiKeysReady) {
        void this.prepareJackpotCheckoutFlow();
      }
      return;
    }

    this.paymentService?.getCheckoutApiDetails(queryParams)
      ?.pipe(
        catchError((err) => {
          return throwError(() => err);
        })
      )
      .subscribe((res: Data) => {
        this.keys = res.data;
        if (!res.data) {
          return;
        }

        this.initializeFrames();
      });
  }

  private prefetchCheckoutApiKeys(): void {
    const queryParams = this.actRoute.snapshot.queryParams || {};
    this.paymentService
      ?.getCheckoutApiDetails(queryParams)
      ?.pipe(
        catchError((err) => {
          return throwError(() => err);
        }),
      )
      .subscribe((res: Data) => {
        this.keys = res.data;
        this.checkoutApiKeysReady = Boolean(res.data?.publicKey);
        if (this.checkoutApiKeysReady) {
          void this.prepareJackpotCheckoutFlow();
        }
      });
  }

  private async prepareJackpotCheckoutFlow(): Promise<void> {
    if (!this.useJackpotTriggerCheckoutFlow || !this.checkoutApiKeysReady || !this.keys?.publicKey) {
      return;
    }
    if (!this.checkOutComData?.customer_purchase) {
      return;
    }

    this.paymentService.checkoutFlowUserId$.next(this.userId);
    const host = this.toPreAuthFlowHost();
    await this.preAuthCheckoutFlowService.warmStart(host);
    void this.tryMountJackpotCheckoutFlow();
  }

  private toPreAuthFlowHost(): PreAuthCheckoutFlowHost {
    return {
      keys: this.keys,
      language: this.language,
      paymentMode: this.paymentMode,
      pathString: this.pathString,
      checkOutComData: this.checkOutComData,
      userId: this.userId,
      preferredCurrency: this.preferredCurrency,
      paymentReason: this.paymentReason,
      isCheckoutComform: this.isCheckoutComform,
      isButtonDisabled: this.isButtonDisabled,
      showCheckOutComSpinner: this.showCheckOutComSpinner,
      errorMessage: this.errorMessage,
      checkoutFlowReady: this.checkoutFlowReady,
      getCheckOutComResponseSubscription: this.getCheckOutComResponseSubscription,
      onFlowReady: () => {
        this.checkoutFlowReady = true;
        this.showCheckOutComSpinner = false;
        this.isButtonDisabled = false;
        if (this.isCheckoutLoadingMessage(this.errorMessage)) {
          this.errorMessage = "";
        }
        this.changeDetectorRef.detectChanges();
      },
    };
  }

  private async tryMountJackpotCheckoutFlow(): Promise<void> {
    if (!this.useJackpotTriggerCheckoutFlow || this.flowMountAttempted) {
      return;
    }
    if (!this.keys?.publicKey || !this.checkOutComData?.customer_purchase) {
      return;
    }

    try {
      this.flowMountAttempted = true;
      this.isCheckoutComform = true;
      this.showCheckOutComSpinner = true;
      this.changeDetectorRef.detectChanges();
      await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));

      const host = this.toPreAuthFlowHost();
      await this.preAuthCheckoutFlowService.mountPreAuthCheckoutFlow(host);
      this.checkoutFlowReady = host.checkoutFlowReady ?? false;
      this.showCheckOutComSpinner = host.showCheckOutComSpinner;
      this.isButtonDisabled = host.isButtonDisabled;
      this.errorMessage = host.errorMessage;
      this.flowInitRetryCount = 0;
      this.changeDetectorRef.detectChanges();
    } catch (error) {
      this.flowMountAttempted = false;
      if ((error as Data)?.code === "checkout_flow_mount_cancelled") { return; }
      if ((error as Data)?.code !== "checkout_flow_ready_timeout" && this.flowInitRetryCount < this.flowInitMaxRetry) {
        this.flowInitRetryCount++;
        setTimeout(() => {
          void this.tryMountJackpotCheckoutFlow();
        }, this.flowInitRetryDelay);
      } else {
        this.errorMessage = "Failed to initialize payment form. Please try again later.";
        this.showCheckOutComSpinner = false;
        this.authService.errorHandlerLogs("Failed to initialize pre-auth checkout flow", error);
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  public isCheckoutLoadingMessage(message: string): boolean {
    return this.preAuthCheckoutFlowService.isCheckoutLoadingMessage(message);
  }

  private onCheckoutFlowPaymentCompleted(): void {
    this.paymentService.checkoutFlowUserId$.next(this.userId);
    this.showCheckOutComSpinner = true;
    this.isCheckoutComform = false;
    this.isButtonDisabled = true;
    this.changeDetectorRef.detectChanges();
    this.loadingService.present();
    this.getCheckOutComResponseSubscription = this.preAuthCheckoutFlowService.waitForPaymentConfirmation(
      this.toPreAuthFlowHost(),
      {
        onSuccess: (paymentResData) => this.handleJackpotFlowPaymentSuccess(paymentResData),
        onFailure: () => this.checkoutPaymentFailedFlow(),
        onTimeout: () => {
          this.errorMessage = "Payment confirmation timed out. Please try again.";
        },
      },
    );
    this.subscription.add(this.getCheckOutComResponseSubscription);
  }

  private handleJackpotFlowPaymentSuccess(paymentResData: Data): void {
    const paymentResponse = paymentResData?.payment_response;
    this.customerPurchaseEncryptedId = paymentResData?.customer_purchase_encrypted_id;
    this.showCheckOutComSpinner = false;

    if (!paymentResponse?.payment_status || paymentResponse?.show_toast) {
      return;
    }

    if (paymentResponse.payment_status !== "success") {
      this.checkoutPaymentFailedFlow();
      return;
    }

    this.loadingService.dismiss();
    this.paymentService.emitSyndicatePurchaseComplete();
    this.completeJackpotTriggerPreAuthAfterPayment(paymentResponse);
  }

  private completeJackpotTriggerPreAuthAfterPayment(paymentResponse?: Data): void {
    this.triggerActivatingData =
      this.triggerActivatingData && Object.keys(this.triggerActivatingData).length
        ? this.triggerActivatingData
        : JSON.parse(localStorage.getItem("JackpotTriggerData") || "{}");

    this.jackpotTriggerObj = {
      alias: this.triggerActivatingData?.alias,
      lines: this.triggerActivatingData?.lines,
      jackpot: this.triggerActivatingData?.jackpot,
      price: this.triggerActivatingData?.price,
      free_jackpot: this.triggerActivatingData?.free_jackpot ?? false,
      alternate_free_jackpot: this.triggerActivatingData?.alternate_free_jackpot ?? false,
      free_offer_id: this.triggerActivatingData?.free_offer_id ?? 0,
      offer_link_id: this.triggerActivatingData?.offer_link_id,
      offer_id: this.triggerActivatingData?.offer_id,
    };

    if (paymentResponse) {
      this.authService.getConstantsMsg("1092").then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Payment has been successfully processed",
            line_2: "",
          },
          style: {
            icon: "tick circle success.png",
            type: "Success",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      });
      paymentResponse.show_toast = true;

      const path_id = `JL4LGZDCJv0wpAfFrAPc`;
      const doc_data = { payment_response: paymentResponse };
      const dv = { docId: this.pathString };
      const method = "update";

      this.authService.getV2CloudFunction("updatefirestoredoc", {
        path_id,
        doc_data,
        dv,
        method,
      }).subscribe({
        error: (error) => {
          return error;
        },
      });
    }

    this.authService.commonUserCheck(() => {
      this.syndicateService
        .activateTrigger(this.jackpotTriggerObj)
        .pipe(
          catchError((error) => {
            return throwError(error);
          }),
        )
        .subscribe(
          (res: Data) => {
            this.paymentService.jackpotPreAuthDone$.next("yes");
            this.paymentService.preAuthActivateTriggerResponse$.next(res);
            if (this.productDetails?.params?.hs_page === "jackpot_triggers") {
              this.router.navigateByUrl("/mainTabs/tabs/home-scroll");
            } else {
              this.router.navigateByUrl("/mainTabs/tabs/store");
            }
            localStorage.removeItem("syndicatePromotion");
          },
          () => {
            this.router.navigateByUrl("/mainTabs/tabs/store");
          },
        );
    });
  }

  private isJackpotTriggerPreAuthRequested(): boolean {
    return (
      this.useJackpotTriggerCheckoutFlow ||
      this.productDetails?.params?.jackpotTrigger === "requested"
    );
  }

  private handleCheckoutFlowRedirect(): boolean {
    if (!this.useJackpotTriggerCheckoutFlow || this.checkoutFlowRedirectHandled) {
      return this.checkoutFlowRedirectHandled;
    }
    const queryParams = this.actRoute.snapshot.queryParams || {};
    const redirectReturn = this.checkoutFlowService.parseRedirectReturn(queryParams);
    if (!redirectReturn.isRedirectReturn) {
      return false;
    }

    this.checkoutFlowRedirectHandled = true;
    if (redirectReturn.status === "success") {
      this.applyCheckoutFlowRedirectContext(redirectReturn);
      this.clearCheckoutFlowReturnQueryParams();
      this.onCheckoutFlowPaymentCompleted();
      return true;
    }

    if (redirectReturn.status === "fail") {
      this.clearCheckoutFlowReturnQueryParams();
      this.checkoutPaymentFailedFlow();
      return true;
    }

    return true;
  }

  private applyCheckoutFlowRedirectContext(redirectReturn: CheckoutFlowRedirectReturn): void {
    if (redirectReturn.logId) {
      this.pathString = redirectReturn.logId;
      this.paymentService.setcheckOutComDocId({ docId: String(redirectReturn.logId) });
    }
    if (redirectReturn.userId) {
      this.userId = redirectReturn.userId;
      this.paymentService.checkoutFlowUserId$.next(redirectReturn.userId);
    }
    this.isCheckOutCom = true;
    this.showCheckOutComSpinner = true;
    this.isCheckoutComform = false;
  }

  private clearCheckoutFlowReturnQueryParams(): void {
    const cleaned = this.checkoutFlowService.stripRedirectReturnParams({
      ...this.actRoute.snapshot.queryParams,
    });
    this.router.navigate([], {
      relativeTo: this.actRoute,
      queryParams: cleaned,
      replaceUrl: true,
    });
  }

  public async initializeFrames(): Promise<void> {
    try {
      // Checkout.com Frames is demand-loaded; ensure the script is present before init.
      await this.resourceLoader.loadCheckoutFrames();
      this.isCheckoutComform = true;
      Frames.init({
        publicKey: this.keys?.publicKey,
        localization: this.language,
      });
      this.framesInitRetryCount = 0;
      Frames.addEventHandler(Frames.Events.CARD_VALIDATION_CHANGED, () => this.onCardValidationChanged());
      Frames.addEventHandler(Frames.Events.FRAME_VALIDATION_CHANGED, (event: Data) => this.onValidationChanged(event));
      Frames.addEventHandler(Frames.Events.CARD_TOKENIZATION_FAILED, () => this.onCardTokenizationFailed());
      Frames.addEventHandler(Frames.Events.CARD_TOKENIZED, (event: Data) => this.onCardTokenized(event));
    } catch (error) {
      if (this.framesInitRetryCount < this.framesInitMaxRetry) {
        this.framesInitRetryCount++;
        setTimeout(() => {
          void this.initializeFrames();
        }, this.framesInitRetryDelay);
      } else {
        this.errorMessage = "Failed to initialize payment frames. Please try again later.";
        this.authService.errorHandlerLogs("Failed to initialize payment frames", error);
      }
    }
  }

  public onCardValidationChanged(): void {
    this.isButtonDisabled = !Frames.isCardValid();
  }

  public onValidationChanged(event: Data): void {
    const hasError = !event.isValid && !event.isEmpty;

    if (hasError) {
      this.errorStack.push(event.element);
    } else {
      this.errorStack = this.errorStack.filter((element) => element !== event.element);
    }

    this.errorMessage = this.errorStack.length ? this.getErrorMessage(this.errorStack[this.errorStack.length - 1]) : "";
  }

  public getErrorMessage(element: string): string {
    const errors: { [key: string]: string } = {
      "card-number": "Please enter a valid card number",
      "expiry-date": "Please enter a valid expiry date",
      cvv: "Please enter a valid CVV code",
    };

    return errors[element] || "An error occurred.";
  }

  public onCardTokenizationFailed(): void {
    Frames.enableSubmitForm();
  }

  public onCardTokenized(event: Data): void {
    this.showCheckOutComSpinner = true;
    this.isCheckoutComform = false;
    this.token = event?.token;
    const msn = this.checkOutComData?.msn;
    const defaultAmount = 0;
    const userNumber = msn?.substring(2);
    const paymentData = {
      token: this.token,
      amount: defaultAmount,
      currency: this.preferredCurrency,
      email: this.checkOutComData?.email || msn + "@lottosocial.com",
      name: this.checkOutComData?.name,
      phone: msn,
      userId: this.userId,
      logId: this.pathString,
      customer_purchase: this.checkOutComData?.customer_purchase,
      msn: {
        country_code: `+${this.checkOutComData?.country_code}`,
        number: userNumber,
      },
      payment_reason: this.paymentReason,
      offer_id: this.checkOutComData?.offer_id ?? this.purchaseDetail?.offer_id ?? "",
      prosub_id: this.checkOutComData?.prosub_id ?? localStorage.getItem("prosub_id") ?? null,
    };

    // Pre auth payload update.
    paymentData["sub_status"] = "pre_auth";
    const generateCheckOutToken = this.paymentMode === "sandbox" ? "generatecheckouttokensbv2" : environment.cloudFunctions.generateCheckOutToken;
    this.authService
      ?.getV2CloudFunction(generateCheckOutToken, paymentData)
      .subscribe(
        (res) => {
          if (!res) return;

          if (!res.requiresRedirect && res.approved) {
            this.loadingService.present();
          } else {
            const responseCode = res?.response_code;
            const otpUrl = res?.redirectLink;
            // Fail conditions: non-3D secure or missing redirect link
            if (responseCode === "20150" || responseCode === "40101" || !otpUrl) {
              this.checkoutPaymentFailedFlow();
              return;
            }
            // Normal flow for valid redirect
            this.redirectlink = this.sanitizer.bypassSecurityTrustResourceUrl(otpUrl);
          }
        },
        (err) => {
          return err;
        }
      );

    this.paymentService?.setcheckOutComDocId({ docId: String(this.pathString) });

    const checkoutSub = this.paymentService.getCheckOutComResponse$
      .pipe()
      .subscribe((paymentResData: Data) => {
        const paymentResponse = paymentResData?.payment_response;
        this.customerPurchaseEncryptedId = paymentResData?.customer_purchase_encrypted_id;
        this.showCheckOutComSpinner = false;
        if (paymentResponse?.payment_status && !paymentResponse?.show_toast) {
          if (paymentResponse?.payment_status === "success") {
            this.loadingService.dismiss();
            this.paymentService.emitSyndicatePurchaseComplete();
            this.triggerActivatingData =
              this.triggerActivatingData && Object.keys(this.triggerActivatingData).length
                ? this.triggerActivatingData
                : JSON.parse(localStorage.getItem("JackpotTriggerData") || "{}");

            if (this.isJackpotTriggerPreAuthRequested()) {
              this.completeJackpotTriggerPreAuthAfterPayment(paymentResponse);
            } else {
              this.subscription.remove(this.callInt2sub);
              this.callInt2();
              this.authService.getConstantsMsg("1092").then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Payment has been successfully processed",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle success.png",
                    type: "Success",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              });
              paymentResponse.show_toast = true;

              const path_id = `JL4LGZDCJv0wpAfFrAPc`;
              const doc_data = { payment_response: paymentResponse };
              const dv = { docId: this.pathString };
              const method = "update";

              this.authService.getV2CloudFunction("updatefirestoredoc", {
                path_id,
                doc_data,
                dv,
                method,
              }).subscribe({
                error: (error) => {
                  return error;
                },
              });
            }
          } else {
            this.checkoutPaymentFailedFlow();
          }
        }
      });
    this.subscription.add(checkoutSub);
  }

  public onSubmit(event: Event): void {
    event.preventDefault();
    if (this.useJackpotTriggerCheckoutFlow) {
      this.preAuthCheckoutFlowService.submitPayment();
      return;
    }
    Frames.submitCard();
  }

  //This method used to go back to the store page
  goBack() {
    this.router.navigateByUrl("/mainTabs/tabs/store");
    this.paymentService.preAuthActivateTriggerResponse$.next({ isBackFromPreAuth: true });
  }

  ngOnDestroy() {
    if (this.useJackpotTriggerCheckoutFlow) {
      this.preAuthCheckoutFlowService.unmount();
    }
    if (window.wpwlOptions) {
      window.wpwlOptions.onReady = this.originalOnReady;
    }
    if (this.getCheckoutIdSubscription) {
      this.getCheckoutIdSubscription.unsubscribe();
    }
    this.subscription.unsubscribe();
  }

  private checkoutPaymentFailedFlow() {
    this.loadingService.dismiss();
    this.timerOn = false;
    this.addingCard = false;
    this.addNewCardInProgress = false;
    this.isPaymentDone = false;
    this.isCheckoutComform = true;
    this.redirectlink = this.sanitizer.bypassSecurityTrustResourceUrl(environment.checkOutUrl);
    if (this.useJackpotTriggerCheckoutFlow) {
      this.flowMountAttempted = false;
      this.checkoutFlowRedirectHandled = false;
      this.checkoutFlowReady = false;
      this.preAuthCheckoutFlowService.unmount();
      void this.prepareJackpotCheckoutFlow();
    }
    this.authService.getConstantsMsg("1093").then((translatedMsg) => {
      const defaultMsg = {
        message: {
          line_1: "There is an issue in processing payment",
          line_2: "",
        },
        style: {
          icon: "tick circle error.svg",
          type: "Error",
        },
      };
      this.authService.showToastMessage(translatedMsg, defaultMsg);
    });
  }
}
